export default __webpack_public_path__ + "e66ff5d.png";